import _ from 'lodash';

const events = {
  DELETE_MODAL: 'delete_modal',
  REFRESH_CALENDAR: 'refresh_calendar',
  SPECIFIC_DATE_CALENDAR: 'specific_date_calendar',
  OPEN_MODAL: 'list.open_list',
  OPEN_EVENT_MODAL: 'event.open_modal',
  SHOW_SNACKBAR: 'show_snackbar',
  OPEN_CONFIRMATION_MODAL: 'list.open_confirmation_modal',
  OPEN_CONFIRMATION_DELETE: 'list.open_confirmation_delete',
  CLOSE_MODAL: 'list.close_modal',
  CREATE_ASSET: 'asset.create',
  GET_ASSET_UUID: 'asset.response',
  HAS_NEW_ASSET: 'asset.has_new_asset',
  NEW_OFFER_IMAGE: 'offer_image',
  NEW_EVENT_IMAGE: 'event_image',
  UPDATE_PAYLOAD: 'payload_update',
  REFRESH_TABLE: 'table_refresh',
  GET_PARTNER: 'update_profile',
  //
  OPEN_MODAL_REGISTER: 'open.modal.register',
  OPEN_MODAL_LOGIN: 'open.modal.login',
};

_.forEach(events, (item, idx) => {
  events[idx] = Object.freeze(events[idx]);
});

export default events;
